<template>
  <div class="setting_balloon setting_balloon_column_edit">
    <div class="setting_balloon_content">
      <div class="setting_balloon_content_main customize_setting_content_main">
        <div class="setting_balloon_rows">
          <div class="setting_balloon_rows_label">
            <p class="setting_balloon_rows_label_name">
              {{ screenLabelsProperties.ITEM_NAME_INPUT_TITLE }}
            </p>
            <p class="setting_label">
              {{ screenLabelsProperties.REQUIRE_LABEL }}
            </p>
          </div>
          <div class="setting_balloon_rows_form">
            <input class="setting_form_text" type="text" v-model="item.itemName" :placeholder="screenLabelsProperties.ITEM_NAME_PLACEHOLDER" @input="validateItemName()"/>
            <p class="error-message" v-if="nameError">
              {{ screenMaxlengthProperties.MAX_LENGTH_ITEM_NAME + screenMessagesProperties.OVERLENGTH_ITEM_NAME }}
            </p>
          </div>
        </div>
        <div class="setting_balloon_rows">
          <div class="setting_balloon_rows_label">
            <p class="setting_balloon_rows_label_name">
              {{ screenLabelsProperties.ANNOTATION_INPUT_TITLE }}
            </p>
          </div>
          <div class="setting_balloon_rows_form">
            <input class="setting_form_text" type="text" v-model="item.annotationText" :placeholder="screenLabelsProperties.ANNOTATION_PLACEHOLDER" @input="validateItemAnnotation()"/>
            <p class="error-message" v-if="annotationError">
              {{ screenMaxlengthProperties.MAX_LENGTH_ANNOTATION + screenMessagesProperties.OVERLENGTH_ANNOTATION }}
            </p>
          </div>
        </div>
        <div class="setting_balloon_rows">
          <div class="setting_balloon_rows_label">
            <p class="setting_balloon_rows_label_name">
              {{ screenLabelsProperties.ITEM_RESOURCE_INPUT_TITLE }}
            </p>
            <p class="setting_label">
              {{ screenLabelsProperties.REQUIRE_LABEL }}
            </p>
          </div>
          <div class="setting_balloon_rows_form">
            <template v-for="(_, index) in item.resourceField">
              <div class="setting_balloon_rows_form_box" v-bind:key="index" v-if="index === 0 || checkItemLength(index) !== 0 || isEmptyResources[index]">
                <draggable :list="item.resourceField[index]" :group="{name: 'item-category', put: checkCanAdd(index)}"
                           @add="addItemToResourceField(index)" draggable=".item">
                  <div v-for="(subResource, subIndex) in item.resourceField[index]" :key="subIndex" class="item">
                    <template v-if="!subResource.itemResourceDeleted">
                      <div class="setting_form_wrapper_customize"
                           :class="subResource.display_name ? 'display_form_grid' : ''">
                        <div class="setting_options_category_item customize_setting_item"
                             :class="subResource.isResourceDeletedByMainSystem ? 'resource-delete-setting' : ''"
                             v-bind:style="[!subResource.display_name && checkItemLength(index) !== 1 ? { marginRight: '20px' } : {}]">
                          <svg class="setting_options_category_item_icon" width="10" height="12"
                               xmlns="http://www.w3.org/2000/svg" v-if="subResource.display_name">
                            <g fill="#aaa" fill-rule="evenodd">
                              <path d="M0 0h10v2H0zM0 5h10v2H0zM0 10h10v2H0z"/>
                            </g>
                          </svg>
                          <input type="text" class="customize_input" disabled
                                 :placeholder="screenLabelsProperties.DRAG_DROP_PLACEHOLDER"
                                 :value="subResource.display_name"
                                 :class="subResource.isResourceDeletedByMainSystem ? 'resource-delete-setting' : ''"/>
                        </div>
                        <div v-if="!(subResource.display_name === '' && checkItemLength(index) === 1)"
                             :class="subResource.display_name ? 'setting_form_wrapper_close' : 'setting_form_wrapper_delete'"
                             @click="removeResource(subIndex, index)">
                          <svg v-if="subResource.display_name" width="12" height="12"
                               xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd">
                              <rect fill="#555" width="12" height="12" rx="2"/>
                              <g fill="#FFF">
                                <path d="M2.853 3.893l.99-.99 5.304 5.304-.99.99z"/>
                                <path d="M8.157 2.903l.99.99-5.304 5.304-.99-.99z"/>
                              </g>
                            </g>
                          </svg>
                          <svg v-else width="12" height="12" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#AAA" fill-rule="evenodd">
                              <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"/>
                              <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"/>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="setting_form_wrapper_customize" :class="{'mt-3': checkItemLength(index) !== 0}" slot="footer" v-if="isEmptyResources[index]">
                    <input type="text" class="setting_form_text" :placeholder="screenLabelsProperties.DRAG_DROP_PLACEHOLDER" disabled/>
                  </div>
                </draggable>
                <!-- <button v-if="index >= 1" class="btn btn-light" type="button" @click="removeLine(index)">
                  <b-icon icon="x"></b-icon>
                </button> -->
                <div class="setting_balloon_rows_form_add">
                  <a class="setting_balloon_rows_form_add_btn" @click.prevent="addNewBlankResource(index)">
                    {{ screenLabelsProperties.ADD_BLANK_ITEM_LINK }}
                  </a>
                  <a class="setting_balloon_rows_form_add_btn" @click.prevent="addNewEmptySubResource(index)">
                    {{ screenLabelsProperties.ADD_COLUMN_LINK }}
                  </a>
                </div>
              </div>
            </template>
            <div class="setting_balloon_rows_form_add">
              <a class="setting_balloon_rows_form_add_btn" @click.prevent="addNewLine()">
                {{ screenLabelsProperties.ADD_ROW_LINK }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="setting_balloon_content_sub">
        <ul class="setting_balloon_content_sub_list">
          <li class="setting_balloon_content_sub_item">
            <label class="setting_balloon_content_sub_label" :class="item.itemRequired ? 'is_checked' : ''">
              <div class="setting_balloon_content_sub_label_box">
                <input type="checkbox" v-model="item.itemRequired" id="item_required" :disabled="hasItemRequired" value="true"/>
                <span class="setting_balloon_content_sub_label_name">
                  {{ screenLabelsProperties.REQUIRE_ITEM_LABEL }}
                </span>
              </div>
              <p class="setting_balloon_content_sub_label_text">
                {{ screenLabelsProperties.REQUIRE_ITEM_MESSAGE }}
              </p>
            </label>
          </li>
          <li class="setting_balloon_content_sub_item">
            <label class="setting_balloon_content_sub_label" :class="item.viewAnnotation ? 'is_checked' : ''">
              <div class="setting_balloon_content_sub_label_box">
                <input type="checkbox" v-model="item.viewAnnotation" value="true"/>
                <span class="setting_balloon_content_sub_label_name">
                  {{ screenLabelsProperties.ANNOTATION_OPTION }}
                </span>
              </div>
              <p class="setting_balloon_content_sub_label_text">
                {{ screenLabelsProperties.ANNOTATION_MESSAGE }}
              </p>
            </label>
          </li>
          <li class="setting_balloon_content_sub_item">
            <div class="setting_balloon_content_sub_label">
              <span class="setting_balloon_content_sub_label_name bold">
                {{ screenLabelsProperties.ABOUT_INPUT_TITLE }}
              </span>
              <p class="setting_balloon_content_sub_label_text">
                {{ screenLabelsProperties.ABOUT_MESSAGE }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="setting_balloon_footer">
      <button class="setting_btn_outline setting_btn_small" @click="onClose()">
        {{ screenLabelsProperties.CLOSE_MODAL }}
      </button>
      <button class="setting_btn_primary setting_btn_small" :class="{'setting_btn_disabled': isDisableSubmitButton()}" @click="onSubmit()">
        {{ screenLabelsProperties.SAVE_ITEM }}
      </button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import screenLabelsProperties from "../../../../properties/entry_screen/screen_tab/screen-labels.json";
import screenMessagesProperties from "../../../../properties/entry_screen/screen_tab/screen-messages.json";
import screenMaxlengthProperties from "../../../../properties/entry_screen/screen_tab/screen-maxlength.json";


export default {
  name: "AddItem",
  props: ["item", "availableResource", "resourceFields"],
  components: {
    draggable,
  },
  data: function () {
    return {
      screenLabelsProperties: screenLabelsProperties,
      screenMessagesProperties: screenMessagesProperties,
      screenMaxlengthProperties: screenMaxlengthProperties,
      indexBlank: 1,
      blankItem: {
        display_name: "空白項目",
        name: "blank_item",
        type: "blank",
      },
      hasItemRequired: false,
      isEmptyResources: [true],
      nameError: false,
      annotationError: false
    };
  },
  watch: {
    item() {
      this.validateItemName();
      this.validateItemAnnotation();
      this.checkEmptyGroup();
    }
  },
  methods: {
    validateItemName() {
      this.nameError = this.item.itemName.length > screenMaxlengthProperties.MAX_LENGTH_ITEM_NAME;
    },

    validateItemAnnotation() {
      this.annotationError = this.item.annotationText.length > screenMaxlengthProperties.MAX_LENGTH_ANNOTATION;
    },

    isDisableSubmitButton() {
      return !this.checkResourceSubmit() || !this.item.itemName || this.item.itemName.trim() === "" || this.nameError || this.annotationError;
    },

    checkResourceSubmit() {
      let result = true;
      if (this.checkItemLength(0) === 0) {
        result = false;
      } else if (this.checkItemLength(0) === 1) {
        this.item.resourceField[0].forEach((resource) => {
          if (!resource.itemResourceDeleted && resource.display_name === "") {
            result = false;
          }
        });
      }

      return result;
    },

    addItemToResourceField(index) {
      this.item.resourceField[index].forEach((item, indexReource) => {
        this.item.resourceField[index][indexReource] = JSON.parse(JSON.stringify(item));
      });

      this.item.resourceField[index].forEach((item) => {
        if (item.required && !item.itemResourceDeleted) {
          this.item.itemRequired = true;
          this.hasItemRequired = true;
        }

        if (!item.itemResourceDeleted) {
          let originName = "";
          if (item.name && (item.name.includes("careers.") || item.name.includes("educations."))) {
            originName = item.name.substring(item.name.indexOf(".") + 1, item.name.length);
          }

          this.resourceFields.filter(resource =>
          (resource.name === item.name || resource.name === originName) && resource.display_name === item.display_name)
          .forEach(resource => resource.isUsed = true);
          this.$emit("updateResourceFields", this.resourceFields);
        }
      });

      if (index === 0 && this.checkItemLength(index) === 1) {
        for (let i = 0; i < this.item.resourceField[index].length; i++) {
          if (!this.item.resourceField[index][i].itemResourceDeleted) {
            if (this.item.resourceField[index][i].property_category_name === "educations" || this.item.resourceField[index][i].property_category_name === "careers") {
              this.$emit("updateFirstResourceCategory", this.item.resourceField[index][i].property_category_name);
            } else {
              this.$emit("updateFirstResourceCategory", "other");
            }

            break;
          }
        }
      }

      this.isEmptyResources[index] = false;
      this.isEmptyResources = JSON.parse(JSON.stringify(this.isEmptyResources));
    },

    addNewEmptySubResource(index) {
      this.isEmptyResources[index] = true;
      this.isEmptyResources = JSON.parse(JSON.stringify(this.isEmptyResources));
    },

    addNewBlankResource(index) {
      this.blankItem = {
        display_name: "空白項目 " + this.indexBlank,
        name: "blank_item",
        type: "blank",
      };

      this.item.resourceField[index].splice(this.item.resourceField[index].length, 0, this.blankItem);
      this.indexBlank++;
    },

    removeResource(subIndex, index) {
      let itemRemove = this.item.resourceField[index][subIndex];
      let originName = this.getOriginResourceName(itemRemove);

      this.item.resourceField[index][subIndex] = JSON.parse(JSON.stringify(this.item.resourceField[index][subIndex]));
      this.item.resourceField[index][subIndex].itemResourceDeleted = true;
      this.item.resourceField = [...this.item.resourceField];

      this.resourceFields
        .filter(resource => (resource.name === itemRemove.name || resource.name === originName) && resource.display_name === itemRemove.display_name && resource.isUsed)
        .map(resource => delete resource.isUsed);
      this.$emit("updateResourceFields", this.resourceFields);

      this.checkItemSettingHasResourceRequired(this.item);

      if (this.checkItemLength(0) === 0) {
        this.isEmptyResources[index] = true;
        this.isEmptyResources = JSON.parse(JSON.stringify(this.isEmptyResources));
      }

      this.checkEmptyResource();
    },

    checkItemSettingHasResourceRequired(item){
      if (!item.resourceField || item.resourceField.length === 0) {
        return;
      }
      let isRequired = false;
      for (let i = 0; i < item.resourceField.length; i++) {
        for (let j = 0; j < item.resourceField[i].length; j++) {
          if (item.resourceField[i][j].itemResourceDeleted) {
            continue;
          }

          if (item.resourceField[i][j].required) {
            isRequired = true;
            break;
          }
        }

        if (isRequired) {
          break;
        }
      }

      if (isRequired) {
        this.item.itemRequired = true;
        this.hasItemRequired = true;
      } else {
        this.item.itemRequired = false;
        this.hasItemRequired = false;
      }
    },

    getOriginResourceName(resourceName){
      if(!resourceName || !resourceName.name || !resourceName.name.includes("careers.") || !resourceName.name.includes("educations.")) {
        return "";
      }
      return resourceName.name.substring(resourceName.name.indexOf(".") + 1, resourceName.name.length);
    },

    checkEmptyResource(){
      let isResourceEmpty = true;
      for (let i = 0; i < this.item.resourceField.length; i++) {
        if (this.checkItemLength(i) !== 0) {
          isResourceEmpty = false;
        }
      }

      if (isResourceEmpty) {
        this.$emit("resetFirstResourceCategory");
      }
    },

    addNewLine() {
      if (this.checkItemLength(0) === 0) {
        return;
      }

      let lastIndex = this.item.resourceField.length - 1;
      if (this.checkItemLength(lastIndex) === 0 && this.isEmptyResources[lastIndex]) {
        return;
      }

      this.item.resourceField.push([]);
      this.isEmptyResources.push(true);
    },

    checkItemLength(index) {
      let length = 0;
      this.item.resourceField[index].forEach(i => {
        if (!i.itemResourceDeleted) {
          length++;
        }
      });

      return length;
    },

    checkCanAdd(index) {
      return this.isEmptyResources[index] && this.availableResource;
    },

    checkEmptyGroup() {
      this.isEmptyResources = [];
      this.item.resourceField.forEach(resourceGroup => {
        if (resourceGroup.length === 0) {
          this.isEmptyResources.push(true);
        } else {
          this.isEmptyResources.push(false);
        }
      })
    },

    onSubmit() {
      this.isEmptyResources = [true];
      this.$emit('submit');
    },

    onClose() {
      this.isEmptyResources = [true];
      this.$emit('close');
    }
  },
};
</script>

<style lang="css" scoped>
a:hover {
  color: #db8f57;
  text-decoration: unset;
  cursor: pointer;
}

.setting_options_category_item_icon,
.customize_input {
  cursor: pointer;
}

.customize_input {
  border: unset !important;
  background-color: #ffff;
  min-height: 32px;
  width: 100%;
  padding: 8px;
}

.customize_setting_item {
  padding: 0 10px !important;
}

.setting_form_wrapper_close {
  top: 55% !important;
}

.setting_form_wrapper_delete {
  margin: 8px 0 0 8px !important;
}

.customize_setting_content_main {
  padding: 16px 14px !important;
}

.setting_form_wrapper_customize {
  position: relative;
  align-items: center;
  display: grid;
}

.display_form_grid {
  display: grid;
}

.display_form_flex {
  display: flex;
}

.setting_form_wrapper_delete {
  top: 45% !important;
  position: absolute;
  right: 2px;
  cursor: pointer;
  transform: translateY(-50%);
}

.setting_flex_input_icon {
  margin-right: 20px;
}
</style>
